define('GoferParts.Collection.View', [
  'SCCollectionView',
  'GoferParts.Details.View',
  'gofer_model_collection.tpl',
  'jQuery'
], function (
  SCCollectionViewModule,
  GoferPartsDetailsView,
  gofer_model_collection_tpl,
  jQuery
) {
  'use strict';

  var SCCollectionView = SCCollectionViewModule.SCCollectionView;

  function GoferPartsCollectionView(options) {
    var self = this;

    SCCollectionView.call(this, options.collection);

    this.collection = options.collection;
    this.application = options.application;
    this.template = gofer_model_collection_tpl;

    this.collection.on('reset sync add remove change destroy', function () {
      self.render();
    });
  }

  GoferPartsCollectionView.prototype = Object.create(SCCollectionView.prototype);
  GoferPartsCollectionView.prototype.constructor = GoferPartsCollectionView;

  GoferPartsCollectionView.prototype.getCellViewsPerRow = function () {
    return 1;
  };

  GoferPartsCollectionView.prototype.getCellViewInstance = function (model) {
    return new GoferPartsDetailsView({
      model: model,
      application: this.application
    });
  };

  GoferPartsCollectionView.prototype.getEvents = function () {
    return {
    };
  };

  GoferPartsCollectionView.prototype.getContext = function () {
    return {};
  };

  return GoferPartsCollectionView;
});
